import image from 'assets/images/finance/insights/gtm.png'
import { Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { RequestInfoButton } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/components/Buttons/RequestInfo'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/components/Buttons/UploadPayroll'
import { Base } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/variants/base'

import { sections } from './sections'

export const NoPayrollButExpenses = () => {
  return (
    <Base
      information={{
        motion: {
          url: image,
          alt: i18n.t('finance.financial_workspace.payroll.landing.title'),
          type: 'image',
        },
        body: {
          title: i18n.t('finance.financial_workspace.payroll.landing.expenses_sections.title'),
          description: i18n.t(
            'finance.financial_workspace.payroll.landing.expenses_sections.description'
          ),
          children: (
            <>
              <RequestInfoButton featureRequested={Features.expenses_core} />
              <UploadPayrollButton type="outline" />
            </>
          ),
        },
      }}
      sections={sections()}
    />
  )
}
